/**
 * Which build this is (docs/BUILD.md, *Public web*). `local` is every build made on the Mac or in a session VM — the
 * tunnel play-test and dev — and keeps every URL debug flag. `beta` and `public` are the Cloudflare Pages builds
 * (`npm run deploy:beta`, `npm run deploy:public`): beta is Kevin's pre-release check and keeps the flags; public is
 * the build players get, where only the harmless flags survive (boot/publicUrl.ts). Set at build time by VITE_CHANNEL.
 */
export type Channel = "local" | "beta" | "public";

export function parseChannel(raw: unknown): Channel {
  return raw === "beta" || raw === "public" ? raw : "local";
}

export const CHANNEL: Channel = parseChannel(import.meta.env.VITE_CHANNEL);
